<template>
  <ProDialog
    ref="proDialogRef"
    :title="'新增买粮人'"
    labelPosition="top"
    :fields="fields"
    :formData.sync="buyerForm"
    :rules="rules"
    :width="'500px'"
    labelWidth="110px"
    :onConfirm="handleConfirm"
  ></ProDialog>
</template>

<script>
import { addBuyer } from '@/api/warehousingService'
import ProDialog from '@/components/dialog/ProDialog.vue'

export default {
  name: 'AddBuyerModal',
  components: {
    ProDialog
  },

  data() {
    return {
      buyerForm: {
        name: '',
        idCardNumber: '',
        // socialCreditCode: '',
        address: ''
      },
      rules: {
        name: [{ required: true, message: '请输入买粮人名称/姓名', trigger: 'blur' }],
        idCardNumber: [{ required: true, message: '请输入身份证号/统一社会信用代码', trigger: 'blur' }],
        // socialCreditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }]
      }
    }
  },
  computed: {
    fields() {
      return [
        {
          prop: 'name',
          label: '买粮人',
          type: 'input',
          editable: true,
          props: {
            placeholder: '请输入买粮人名称/姓名'
          }
        },
        {
          prop: 'idCardNumber',
          label: '身份证号/统一社会信用代码',
          type: 'input',
          editable: true,
          props: {
            placeholder: '请输入身份证号/统一社会信用代码'
          }
        },
        // {
        //   prop: 'socialCreditCode',
        //   label: '社会信用代码',
        //   type: 'input',
        //   editable: true,
        //   props: {
        //     placeholder: '请输入统一社会信用代码'
        //   }
        // },
        {
          prop: 'address',
          label: '地址',
          type: 'textarea',
          editable: true,
          props: {
            placeholder: '请输入地址'
          }
        }
      ]
    }
  },
  methods: {
    async handleConfirm() {
      try {
        let dto = {
          name: this.buyerForm.name,
          idCardNumber: this.buyerForm.idCardNumber,
          address: this.buyerForm.address
        }
        console.log('dto', dto,this.buyerForm)
        const res = await addBuyer(dto)
        // console.log('新增买粮人结果', res)
        if (res.code==0) {
          this.$message.success('新增成功')
          this.$emit('confirm', res.data)
          this.handleClose()
        } else {
          this.$message.error(res.msg || '新增失败')
        }
      } catch (error) {
        this.$message.error('新增失败')
        console.error('新增买粮人失败', error)
      }
    },

    handleClose() {
      this.$refs.proDialogRef.handleClose()
    },
    
    handleOpen() {
      this.$refs.proDialogRef.handleOpen()
    }
  }
}
</script>

<style scoped lang="less">
/* 可以根据需要添加样式 */
</style>
